/* Warenkorb-Seite + Seiten-Warenkorb (06.10.2026, überarbeitet nach Prüfung durch 3 Prüfer).
   Ohne JavaScript funktioniert alles über normale Formulare/Links. Mit JavaScript: Hinzufügen, Menge, Entfernen und
   Rabattcode per Cart-API; die Antwort enthält die neu gerenderten Sections (cart-drawer und, auf /cart, die Seite).
   Regeln: Anfragen laufen nacheinander (Warteschlange), Fokus und Scrollposition bleiben erhalten, Fehler sind sichtbar
   und der Warenkorb wird danach mit dem Server abgeglichen. */
(function () {
  "use strict";
  if (!window.fetch || !window.DOMParser) return;
  var drawer = document.getElementById("WkDrawer");
  if (drawer && typeof drawer.showModal !== "function") drawer = null; // alte Browser: normale Links und Formulare
  var statusSeite = document.getElementById("WkStatus");
  var statusDialog = document.getElementById("WkStatusD");
  var meldungSeite = document.getElementById("WkMeldung");
  var meldungDialog = document.getElementById("WkMeldungD");
  var ausloeser = null; // Element, das den Dialog geöffnet hat (Fokus-Rückgabe)

  function aufSeite() { return !!document.querySelector("[data-wk-seite]"); }
  function seitenSektion() {
    var s = document.querySelector("[data-wk-seite]"), w = s && s.closest(".shopify-section");
    return w ? w.id.replace("shopify-section-", "") : null;
  }
  function sektionen() { var a = drawer ? ["cart-drawer"] : []; var s = seitenSektion(); if (s) a.push(s); return a; }
  function dialogOffen() { return !!(drawer && drawer.open); }

  /* ── Ansagen (Screenreader) und sichtbare Meldungen ── */
  function melden(t) {
    var z = dialogOffen() ? statusDialog : statusSeite;
    if (!z) return;
    z.textContent = ""; setTimeout(function () { z.textContent = t; }, 60);
  }
  var meldeTimer = null;
  function zeigen(t) {
    var z = dialogOffen() ? meldungDialog : meldungSeite;
    if (!z) { melden(t); return; }
    z.textContent = t; z.hidden = false;
    clearTimeout(meldeTimer); meldeTimer = setTimeout(function () { z.hidden = true; }, 7000);
  }

  /* ── Neu einsetzen, mit Fokus- und Scroll-Erhalt ── */
  function fokusAnker() {
    var a = document.activeElement;
    if (!a || a === document.body) return null;
    if (!(drawer && drawer.contains(a)) && !(a.closest && a.closest("[data-wk-seite]"))) return null; // nur in neu gezeichneten Bereichen
    var zeile = a.closest && a.closest("[data-wk-zeile]");
    return { rolle: a.getAttribute("data-wk-rolle"), zeile: zeile ? zeile.getAttribute("data-wk-zeile") : null,
             nachbar: zeile && zeile.nextElementSibling ? zeile.nextElementSibling.getAttribute("data-wk-zeile") : null,
             imDialog: !!(drawer && drawer.contains(a)) };
  }
  function fokusSetzen(anker) {
    if (!anker) return;
    var wurzel = anker.imDialog ? drawer : document;
    var ziel = null;
    if (anker.zeile && anker.rolle) ziel = wurzel.querySelector('[data-wk-zeile="' + anker.zeile + '"] [data-wk-rolle="' + anker.rolle + '"]');
    if (!ziel && !anker.zeile && anker.rolle && anker.rolle.indexOf("pd-") !== 0) ziel = wurzel.querySelector('[data-wk-rolle="' + anker.rolle + '"]');
    if (!ziel && anker.zeile) ziel = wurzel.querySelector('[data-wk-zeile="' + anker.zeile + '"] .wk-name');
    if (!ziel && anker.nachbar) ziel = wurzel.querySelector('[data-wk-zeile="' + anker.nachbar + '"] .wk-name');
    if (!ziel && anker.rolle && anker.rolle.indexOf("pd-") === 0) ziel = wurzel.querySelector(".pd-knopf") || wurzel.querySelector(".wk-name");
    if (!ziel) ziel = wurzel.querySelector(".wk-name") || wurzel.querySelector("[data-wk-leer]") || (anker.imDialog ? drawer.querySelector("[data-wk-zu]") : null);
    if (ziel) ziel.focus({ preventScroll: !anker.imDialog });
  }
  function einsetzen(map) {
    if (!map) return;
    var anker = fokusAnker();
    var liste = drawer && drawer.querySelector(".wk-haupt"), scroll = liste ? liste.scrollTop : 0;
    Object.keys(map).forEach(function (id) {
      var alt = document.getElementById("shopify-section-" + id);
      if (!alt || !map[id]) return;
      var neu = new DOMParser().parseFromString(map[id], "text/html").getElementById("shopify-section-" + id);
      alt.innerHTML = neu ? neu.innerHTML : map[id];
    });
    var l2 = drawer && drawer.querySelector(".wk-haupt"); if (l2) l2.scrollTop = scroll;
    fokusSetzen(anker); zaehler(); leiste();
  }
  function zaehler() {
    var n = document.querySelector("[data-wk-anzahl]");
    if (!n) return;
    var c = +n.getAttribute("data-wk-anzahl");
    [].forEach.call(document.querySelectorAll("[data-cart-count]"), function (el) { el.textContent = c; el.hidden = c === 0; });
    [].forEach.call(document.querySelectorAll(".site-header a[href$='/cart']"), function (a) {
      a.setAttribute("aria-label", c ? "Warenkorb, " + c + " Artikel" : "Warenkorb, leer");
    });
  }
  function gesamt() { var n = document.querySelector("[data-wk-gesamt]"); return n ? n.getAttribute("data-wk-gesamt") : ""; }

  /* ── Netz: Warteschlange, damit Änderungen nacheinander laufen ── */
  var schlange = Promise.resolve();
  function nacheinander(fn) { schlange = schlange.then(fn, fn); return schlange; }
  function json(r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { j.status = r.status; throw j; } return j; }); }
  function post(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }).then(json);
  }
  function frisch() { // Sections mit dem echten Warenkorb abgleichen
    var s = sektionen(); if (!s.length) return Promise.resolve();
    return fetch(location.pathname + "?sections=" + s.join(",")).then(json).then(einsetzen).catch(function () {});
  }
  function sperren(an) {
    [].forEach.call(document.querySelectorAll("[data-wk]"), function (w) {
      w.classList.toggle("wk-laedt", an);
      if (an) w.setAttribute("aria-busy", "true"); else w.removeAttribute("aria-busy");
    });
  }
  function fehlertext(f) {
    var t = f && (f.description || f.message);
    if (t && typeof t === "string") return t;
    return "Das hat leider nicht geklappt. Bitte versuche es noch einmal.";
  }

  /* ── Seiten-Warenkorb öffnen/schließen ── */
  function oeffnen(von) {
    if (!drawer || aufSeite() || drawer.open) return;
    ausloeser = von || document.activeElement;
    drawer.showModal();
    document.documentElement.classList.add("wkd-offen");
    var zu = drawer.querySelector("[data-wk-zu]"); if (zu) zu.focus();
  }
  function schliessen() { if (drawer && drawer.open) drawer.close(); }
  if (drawer) {
    drawer.addEventListener("close", function () {
      document.documentElement.classList.remove("wkd-offen");
      if (meldungDialog) meldungDialog.hidden = true;
      if (ausloeser && document.contains(ausloeser) && ausloeser.focus) ausloeser.focus();
      ausloeser = null;
    });
    drawer.addEventListener("click", function (e) { if (e.target === drawer) schliessen(); }); // Klick auf den Hintergrund
  }

  /* ── Menge / Entfernen ── */
  function aendern(keys, menge, el, hinweis) {
    if (!keys) return;
    var zeile = el && el.closest("[data-wk-zeile]");
    var name = zeile ? zeile.getAttribute("data-wk-name") : "Artikel";
    var updates = {};
    keys.split(",").forEach(function (k, i) { if (k) updates[k] = i === 0 ? menge : 0; });
    nacheinander(function () {
      sperren(true);
      return post("/cart/update.js", { updates: updates, sections: sektionen().join(","), sections_url: location.pathname })
        .then(function (j) {
          einsetzen(j.sections);
          if (hinweis && zeile) { var z = document.querySelector('[data-wk-zeile="' + zeile.getAttribute("data-wk-zeile") + '"] [data-wk-fehler]'); if (z) { z.textContent = hinweis; z.hidden = false; } }
          melden((hinweis ? hinweis + " " : "") + (menge === 0 ? name + " entfernt. " + (document.querySelector("[data-wk-leer]") ? "Dein Warenkorb ist leer." : "Gesamt " + gesamt() + ".")
                             : name + ": Menge " + menge + ". Gesamt " + gesamt() + "."));
        })
        .catch(function (f) {
          var t = fehlertext(f);
          return frisch().then(function () {
            var z = keys && document.querySelector('[data-wk-zeile="' + (zeile ? zeile.getAttribute("data-wk-zeile") : "") + '"] [data-wk-fehler]');
            if (z) { z.textContent = t; z.hidden = false; } else zeigen(t);
            melden(t);
          });
        })
        .then(function () { sperren(false); });
    });
  }

  /* ── Aktionscode ── */
  function codeAnwenden(code) {
    nacheinander(function () {
      sperren(true);
      return post("/cart/update.js", { discount: code, sections: sektionen().join(","), sections_url: location.pathname })
        .then(function (j) {
          var treffer = (j.discount_codes || []).filter(function (d) { return (d.code || "").toLowerCase() === code.toLowerCase(); })[0];
          if (treffer && treffer.applicable) { einsetzen(j.sections); melden("Code " + code + " ist aktiv. Gesamt " + gesamt() + "."); return; }
          var rest = (j.discount_codes || []).filter(function (d) { return d.applicable && (d.code || "").toLowerCase() !== code.toLowerCase(); }).map(function (d) { return d.code; });
          return post("/cart/update.js", { discount: rest.join(","), sections: sektionen().join(","), sections_url: location.pathname })
            .then(function (j2) { einsetzen(j2.sections); zeigen("Der Code " + code + " gilt für diesen Warenkorb nicht."); });
        })
        .catch(function (f) { zeigen(fehlertext(f)); })
        .then(function () { sperren(false); });
    });
  }

  /* ── Klicks, Eingaben ── */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-wk-zu]")) { e.preventDefault(); schliessen(); return; }
    var korb = t.closest(".site-header a[href$='/cart']");
    if (korb && drawer && !aufSeite() && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); frisch().then(function () { oeffnen(korb); }); return; }
    if (t.closest('[aria-disabled="true"].wk-mbtn')) { e.preventDefault(); return; }
    var m = t.closest("[data-wk-menge]");
    if (m) { e.preventDefault(); aendern(m.getAttribute("data-wk-keys"), Math.max(0, +m.getAttribute("data-wk-menge")), m); return; }
    var c = t.closest("[data-wk-code]");
    if (c) { e.preventDefault(); codeAnwenden(c.getAttribute("data-wk-code")); }
  });
  var tippTimer = null;
  function mengeAusFeld(i) {
    if (!document.contains(i)) return; // schon neu gezeichnet (Enter + change)
    var v = (i.value || "").trim(), n = parseInt(v, 10), max = parseInt(i.getAttribute("data-wk-max"), 10), hinweis = "";
    if (v === "" || isNaN(n) || n < 0) { i.value = i.defaultValue; return; } // leeres Feld löscht nicht
    if (!isNaN(max) && n > max) { n = max; hinweis = "Es sind nur noch " + max + " Stück verfügbar."; }
    if (String(n) === i.defaultValue && !hinweis) return;
    if (i.getAttribute("data-wk-gesendet") === String(n)) return;
    i.setAttribute("data-wk-gesendet", String(n));
    aendern(i.getAttribute("data-wk-keys"), n, i, hinweis);
  }
  document.addEventListener("change", function (e) {
    var i = e.target.closest && e.target.closest(".wk-mzahl");
    if (!i) return;
    clearTimeout(tippTimer); tippTimer = setTimeout(function () { mengeAusFeld(i); }, 500);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.classList && e.target.classList.contains("wk-mzahl")) { e.preventDefault(); clearTimeout(tippTimer); mengeAusFeld(e.target); }
  });

  /* ── In den Warenkorb (Produktseite, Produktkarten, „Passt dazu") ── */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches || !f.matches("form[action*='/cart/add']")) return;
    if (!drawer && !aufSeite()) return; // ohne Seiten-Warenkorb: normales Formular (→ /cart)
    e.preventDefault();
    var knopf = f.querySelector("[type=submit]"), vorher = knopf ? knopf.innerHTML : "";
    if (knopf && knopf.getAttribute("aria-disabled") === "true") return;
    if (knopf) { knopf.setAttribute("aria-disabled", "true"); knopf.setAttribute("aria-busy", "true"); if (!knopf.closest(".pd--drawer")) knopf.textContent = "Wird hinzugefügt …"; }
    var fd = new FormData(f);
    fd.append("sections", sektionen().join(","));
    fd.append("sections_url", location.pathname);
    nacheinander(function () {
      return fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } }).then(json)
        .then(function (j) {
          if (knopf && document.contains(knopf)) { knopf.removeAttribute("aria-disabled"); knopf.removeAttribute("aria-busy"); knopf.innerHTML = vorher; }
          var name = j.product_title || j.title || "Artikel";
          var von = knopf && document.contains(knopf) && !(drawer && drawer.contains(knopf)) ? knopf : null;
          einsetzen(j.sections);
          oeffnen(von);
          melden(name + " liegt im Warenkorb. Gesamt " + gesamt() + ".");
        }, function (err) {
          if (knopf) { knopf.removeAttribute("aria-disabled"); knopf.removeAttribute("aria-busy"); knopf.innerHTML = vorher; }
          zeigen(fehlertext(err));
        });
    });
  });

  /* ── Zurück-Navigation (bfcache): Warenkorb abgleichen ── */
  window.addEventListener("pageshow", function (e) {
    var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (e.persisted || (nav && nav.type === "back_forward")) frisch();
  });

  /* ── Feste Leiste unten (Handy): ausblenden, solange der Kassen-Knopf im Überblick sichtbar ist ── */
  var beobachter = null;
  function leiste() {
    var l = document.querySelector("[data-wk-leiste]"), k = document.querySelector(".wk--seite [data-wk-kasse]");
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    if (!l || !k || !("IntersectionObserver" in window)) return;
    beobachter = new IntersectionObserver(function (es) {
      var sichtbar = es[0].isIntersecting;
      if (sichtbar) { l.setAttribute("data-versteckt", ""); l.setAttribute("inert", ""); }
      else { l.removeAttribute("data-versteckt"); l.removeAttribute("inert"); }
    });
    beobachter.observe(k);
  }
  leiste(); zaehler();
})();
